import React, { useRef } from 'react';
import { HelpCircle, MapPin, Truck, ChevronDown, ChevronUp } from 'lucide-react';

import { MegaMenu } from './MegaMenu';
import { useOutsideClick } from './hooks';
import styles from './Header.module.css';
import { Logo } from '@/components/layout/Header/Logo';
import { ButtonOutlined } from '@/components/ui/Button/ButtonOutlined';
import { ButtonFilled } from '@/components/ui/Button/ButtonFilled';
import Link from 'next/link';
import { handleScroll } from '@/lib/utils/scroll';

interface DesktopHeaderProps {
    openMegaMenu: string | null;
    onMegaMenuToggle: (menuId: string) => void;
}

export const DesktopHeader: React.FC<DesktopHeaderProps> = ({ openMegaMenu, onMegaMenuToggle }) => {
    const navRef = useRef<HTMLElement>(null as unknown as HTMLElement);
    useOutsideClick(navRef, () => {
        if (openMegaMenu) {
            onMegaMenuToggle(openMegaMenu);
        }
    });

    return (
        <div className={`${styles.container} ${styles.desktopContainer}`}>
            <div className={styles.topRow}>
                <div className={styles.leftSection}>
                    <div className={styles.logo}>
                        <Logo />
                    </div>
                </div>
                <div className={styles.rightSection}>
                    <Link href="/faq" className={styles.secondaryLink}>
                        <HelpCircle size={20} />
                        <span>Помощь</span>
                    </Link>
                    <Link href="/points-cdek" className={styles.secondaryLink}>
                        <MapPin size={20} />
                        <span>Пункты CDEK</span>
                    </Link>
                    <Link href="#" className={styles.secondaryLink}>
                        <Truck size={20} />
                        <span>Отправляйте как юрлицо</span>
                    </Link>
                </div>
            </div>

            <div className={styles.bottomRow}>
                <nav ref={navRef} className={styles.bottomNavContainer}>
                    <ul className={styles.bottomNavList}>
                        <li className={styles.bottomNavItem}>
                            <button
                                className={`${styles.bottomNavLink} ${styles.dropdownLink} ${openMegaMenu === 'send-receive' ? styles.activeTrigger : ''}`}
                                onClick={() => onMegaMenuToggle('send-receive')}
                            >
                                <span>Сервисы и продукты</span>
                                {openMegaMenu === 'send-receive' ? (
                                    <ChevronUp size={20} />
                                ) : (
                                    <ChevronDown size={20} />
                                )}
                            </button>
                            {openMegaMenu === 'send-receive' && <MegaMenu menuId="send-receive" />}
                        </li>

                        <span className={styles.bottomNavItem}>
                            <div
                                className={styles.bottomNavLink}
                                style={{ color: 'rgb(153, 153, 153)', cursor: 'default' }}
                            >
                                Тарифы
                            </div>
                        </span>

                        <li className={styles.bottomNavItem}>
                            <Link href="/tracking" className={styles.bottomNavLink}>
                                Отследить посылку
                            </Link>
                        </li>

                        <li className={styles.bottomNavItem}>
                            <Link href="/calculator" className={styles.bottomNavLink}>
                                Калькулятор доставки
                            </Link>
                        </li>

                        <div className={styles.bottomNavItem}>
                            <button
                                onClick={() => handleScroll('cta-section', 100)}
                                className={styles.bottomNavLink}
                                style={{ cursor: 'pointer' }}
                            >
                                Заключить договор
                            </button>
                        </div>
                    </ul>
                </nav>
                <div className={styles.bottomRightSection}>
                    <ButtonOutlined>ОНЛАЙН-ОПЛАТА</ButtonOutlined>
                    <ButtonFilled full={false}>ВОЙТИ</ButtonFilled>
                </div>
            </div>
        </div>
    );
};
